<template>
  <div>
    <page-main
      ref="main"
      :loading="loading"
      :table-data="table"
      :tablePage="page"
      @reload="reload"
      @submit="submitSuccess"
    >
      <page-header
        @reset="reset"
        @submit="handleSubmit"
        slot="header"
        ref="header"
      ></page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      ></pagination
    ></page-main>
  </div>
</template>
<script>
export default {
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main'),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      }
    },
    submitSuccess(fabricStockInCode) {
      this.$emit('submitSuccess', fabricStockInCode)
    },
    reload() {
      this.$refs.header.query()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .fabricRequestNotInStockApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
